import { Text, TextType } from 'ui-components/components/text';

import { getCarrierInitials, getCarrierLogoSrc } from '@shipstation/client-common/components/freight-rate-card';

import style from '../../orders/order-details/rate-card/label-provider-logo/label-provider-logo.module.css';

type FreightLogoProps = {
  freightCarrierName: string;
  freightCarrierScac?: string;
};

export const FreightLogo = ({ freightCarrierName, freightCarrierScac }: FreightLogoProps) => {
  const freightLogoSrc = getCarrierLogoSrc(freightCarrierScac);

  if (freightLogoSrc) {
    return <img alt={freightCarrierName} className={style['freight-logo-image']} src={freightLogoSrc} />;
  }

  return <Text isBold textType={TextType.Paragraph} value={getCarrierInitials(freightCarrierName)} />;
};
